// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"4191dc4f","453":"66278fc8","705":"86baede0","740":"f98d4cc1","788":"360aacbc"}[chunkId] + ".chunk.js";
};